export enum TransactionSrc {
  'KNOSTOS' = 'KNOSTOS',
  'PORTAL' = 'PORTAL',
  'MOBILE_GATEWAY' = 'MOBILE_GATEWAY',
}
